define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/topic",
	"underscore",
	"csi",
	"csi/_base/modules",
	"csi/access/crews",
	"csi/action/Download",
	"csi/action/Popup",
	"csi/action/Submit",
	"csi/breadcrumb/FavoriteList",
	"csi/breadcrumb/LastVisited",
	"csi/configuration",
	"csi/configurationUtil",
	"csi/def",
	"csi/def/Action",
	"csi/def/Request",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/message",
	"csi/page/HeaderSearchForm",
	"csi/page/HelpPane",
	"csi/page/SearchManager",
	"csi/page/ToolbarPluginUser",
	"csi/reflection",
	"csi/session",
	"csi/sessionActions",
	"csi/sessionConstants",
	"csi/state",
	"csi/state/datasetup",
	"csi/state/rootStore",
	"csi/store/_base",
	"csi/view/Toolbar",
	"csi/view/ToolbarPluginAnchor",
	"csi/view/ToolbarPluginMenu",
	"csi/view/Widget",
	"csi/widget/MessageDialog",
	"csi/xml",
	"dojo/text!csi/templates/headerToolbars.html"
], function(declare, lang, topic, _, csi, modules, crews, DownloadAction, Popup, SubmitAction, FavoriteList, LastVisited,
	configuration, configurationUtil, def, Action, Request, ViewRef, locale, message,
	HeaderSearchForm, HelpPane, SearchManager, ToolbarPluginUser, reflection, session, sessionActions, sessionConstants, state,
	{dataSetupStore}, {sessionStore, watchStoreProperty}, csiStore, Toolbar, ToolbarPluginAnchor, ToolbarPluginMenu,
	Widget, MessageDialog, xml, template) {

	const ACTION_FAVORITES = "UserFavorite";
	const ACTION_HELP = "Help";
	const ACTION_LAST_VISITED = "LastVisited";
	const ACTION_NOTIFICATION = "Notifications";
	const ACTION_SYSTEM_CONFIGURATION = "SystemConfiguration";
	const ATTR_ROLEPLAYED = "RolePlayed";
	const CSS_GROUP_LABEL = "csi-menu-group-label";

	/**
	 * Action Parameters
	 */
	const ADMIN_ONLY = {
		m_id: "AdminOnlyMode",
		m_onAction: "_onActionAdminOnly",
		m_postAction: "_postActionAdminOnly",
		classToolbarPlugin: ToolbarPluginMenu,
		isToggledInitially: () => sessionStore.adminOnly
	};
	const ADMIN_ONLY_ICON = {
		m_id: "AdminOnlyMode_TT",
		m_typeControl: def.ACTION_ICON,
		materialIcon: "security"
	};
	const DATA_SETUP_LABEL = {
		m_class: CSS_GROUP_LABEL,
		m_id: "DataSetupLabel",
		m_right: xml.RIGHT_NONE
	};
	const EMAIL = {
		m_id: "PageEmail",
		classController: "csi/action/EmailPageController"
	};
	const FAVORITE = {
		m_id: ACTION_FAVORITES,
		m_typeControl: def.ACTION_ICON,
		materialIcon: "star",
		classToolbarPlugin: FavoriteList
	};
	const HELP = {
		m_id: ACTION_HELP,
		m_onAction: () => csi.browserWindow(state.get("helpFile"), "helpWin")
	};
	const HELP_LABEL = {
		m_class: CSS_GROUP_LABEL,
		m_id: "HelpLabel",
		m_right: xml.RIGHT_NONE
	};
	const IMAGE_LIBRARY = {
		m_id: "ImageBrowserManage",
		m_typeControl: def.ACTION_ICON,
		materialIcon: "collections",
		classController: "csi/action/ManageImageController"
	};
	const LAST_VISITED = {
		m_id: ACTION_LAST_VISITED,
		m_class: "iconLastVisited",
		m_typeControl: def.ACTION_ICON,
		materialIcon: "arrow_back",
		classToolbarPlugin: LastVisited
	};
	const LOGOUT = {
		m_id: "Logout",
		m_onAction: () => sessionActions.logoutAction()
	};
	const NOTIFICATION = {
		m_id: ACTION_NOTIFICATION,
		m_typeControl: def.ACTION_ICON,
		materialIcon: "notifications",
		classToolbarPlugin: "csi/notification/ToolbarNewTasks",
	};
	const ROLLUP = {
		m_id: "PageRollupStatus",
		m_viewRef: lang.mixin(new ViewRef(), {
			m_url: reflection.URL_HOME,
			m_id: "RollupStatus"
		})
	};
	const SHOW_HELP = {
		m_id: "ShowHelpPane",
		m_onAction: HelpPane.toggle,
		isToggledInitially: HelpPane.isActive,
	};
	const SYSTEM_CONFIGURATION = {
		m_id: ACTION_SYSTEM_CONFIGURATION,
		classToolbarPluginParams: _getAnchorParams(sessionStore.siteUrl)
	};
	const SYSTEM_REPORTING_LABEL = {
		m_class: CSS_GROUP_LABEL,
		m_id: "SystemReporting",
		m_right: xml.RIGHT_NONE
	};
	const TASKS = {
		m_id: "PageTasks",
		m_name: "",
		m_typeControl: def.ACTION_ICON,
		materialIcon: "library_add_check",
		classToolbarPlugin: "csi/notification/ToolbarAssignedTasks",
		classToolbarPluginParams: _getAnchorParams(reflection.URL_TASKS)
	};
	const UPDATE_CONFIGURATION = {
		m_id: "UpdateConfiguration",
		confirmAction: MessageDialog.BUTTON_RUN,
		m_accessAction: "_canUpdateStatus",
		m_preAction: "_preUpdateConfiguration",
		m_postAction: "_postUpdateConfiguration",
		classController: "SiteAdmin/Config/UpdateConfigurationController"
	};
	const EXPORT_CONFIGURATION = {
		m_id: "ExportConfiguration",
		m_accessAction: "_canUpdateStatus",
		m_preAction: "_preUpdateConfiguration",
		m_request: lang.mixin(new Request(), {
			m_module: "Configuration",
			m_operation: "Export"
		})
	};
	const IMPORT_CONFIGURATION = {
		m_id: "ImportConfiguration",
		m_accessAction: "_canUpdateStatus",
		m_preAction: "_preUpdateConfiguration",
		m_postAction: "_postImportConfiguration",
		m_request: lang.mixin(new Request(), {
			m_module: "Configuration",
			m_operation: "Import"
		}),
		m_viewRef: lang.mixin(new ViewRef(), {
			m_id: "ImportConfiguration",
			m_url: reflection.URL_SITE
		})
	};
	const USER_NAME = {
		m_id: "UserName",
		classToolbarPlugin: ToolbarPluginAnchor
	};
	const USER_PROFILE = {
		m_id: "Profile"
	};

	/**
	 * Menu parameters
	 */
	const DATA_SETUP_MENU = {
		name: "DataSetup",
		materialIcon: "settings"
	};
	const HELP_MENU = {
		name: "Help",
		materialIcon: "help"
	};
	const SYSTEM_MENU = {
		name: "SystemConfiguration",
		materialIcon: "build"
	};
	const USER_MENU = {
		name: "User",
		materialIcon: "account_circle",
		classToolbarPlugin: ToolbarPluginUser
	};

	/**
	 * Return parameters for action to navigate to the given data setup section
	 * @param {DataSetupSection} section
	 * @return {object}
	 */
	function _getDataSetupActionParams(section) {
		if (!section) {
			return null;
		}

		const {href, id, name} = section;

		return {
			m_id: id,
			m_name: name,
			classToolbarPluginParams: {
				anchorHref: href
			}
		};
	}

	/**
	 * Return params for toolbar plugin to link to given node URL
	 * @param {string} nodeUrl
	 * @param {string} [tab]
	 * @return {object}
	 */
	function _getAnchorParams(nodeUrl, tab) {
		return {
			anchorHref: session.getLocationForUrl(nodeUrl, tab ? {[session.LOCATION_TAB]: tab} : null)
		};
	}

	/**
	 * Return action to select role for user to play
	 * @param {string} name
	 * @param {string} url
	 * @return {Action}
	 */
	function _getRoleAction(name, url) {
		const a = lang.mixin(new Action(), {
			confirmAction: MessageDialog.BUTTON_CHANGE,
			m_id: "SelectRole",
			m_name: name,
			m_typeControl: def.ACTION_BUTTON,
			m_onAction: function(ac) {
				ac.m_writer.changeNode(sessionConstants.userUrl).changeAttribute(ATTR_ROLEPLAYED, xml.ATTR_REF, url);
			},
			m_postAction: function(ac) {
				location.reload();
			}
		});
		a.resolve();
		return a;
	}

	return declare(Widget, {
		plugins: null,
		templateString: template,
		widgetsInTemplate: false,

		/** @property {DOMNode} headerSearchNode - header search container */
		headerSearchNode: null,

		/** @property {DOMNode} headerToolbarNode - header toolbar container */
		headerToolbarNode: null,

		postCreate: function() {
			this.inherited(arguments);
			this._initViewActions();

			// initialize global search on header
			if (!sessionConstants.isLocalUser && SearchManager.getFirstSearchType()) {
				new HeaderSearchForm({
					view: this
				}).placeAt(this.headerSearchNode).startup();
			}

			// if role previously played was removed, then notify user and update setting
			const urlRolePlayed = sessionConstants.roleUrl || csi.EMPTY_URL;
			const urlRoleOld = sessionStore.currentUser.RolePlayed;

			if (urlRoleOld != urlRolePlayed) {
				this.writeOperations((writer) => {
					writer.changeNode(sessionConstants.userUrl).changeAttribute(ATTR_ROLEPLAYED, xml.ATTR_REF, urlRolePlayed);
				});

				if (!crews.isAdmin() && (urlRoleOld != csi.EMPTY_URL)) {
					message.errorDialog({
						materialIcon: MessageDialog.ICON_WARNING,
						title: locale.resource("WARNING"),
						message: locale.resource("ErrorRoleNotFound")
					});
				}
			}

			const enableToolbar = () => this._enableToolbar();
			const redraw = () => this.redraw();
			const reset = () => this._resetDropDowns();

			// disable configuration actions while updating configuration
			topic.subscribe("/csi/configuration/refresh", enableToolbar);

			// reset drop downs for Last Visited and Favorites
			topic.subscribe("/csi/hash/end", reset);
			topic.subscribe("/csi/pageHeader/refresh", reset);

			// need to redraw to show updated role selection
			topic.subscribe("/csi/roles/change", redraw);

			// need to redraw to toggle between Hide/Show Help Pane or when user name changes
			watchStoreProperty(sessionStore, "showHelp", redraw);
			watchStoreProperty(sessionStore, "userName", redraw);

			this.set("disabled", false);
		},

		/**
		 * @override
		 * Override default implementation as any changes to header will not affect size of rest of application
		 */
		publishDomChange: function(domNode) { },

		/**
		 * @override
		 * Populate toolbar with actions
		 */
		_buildView: function() {
			const {headerToolbar, headerToolbarNode} = this;

			if (headerToolbar) {
				headerToolbar.destroyRecursive();
			}

			this._resetToolbarPlugins();
			this.headerToolbar = new Toolbar().placeAt(headerToolbarNode);
			this.headerToolbar.setView(this);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Header toolbar does not need to be disabled when any actions is performed, as usual; they will only be disabled in particular situations
		 */
		_disableView: function(disabled) { },

		/**
		 * Update disabled state of toolbar plugins
		 */
		_enableToolbar: function() {
			const {headerToolbar} = this;

			if (headerToolbar) {
				headerToolbar.enablePlugins();
			}
		},

		_getRootRequest: function(/*Node*/node) {
			// summary: header gets data from resolver cache and does not need to query for it each time redrawn
			return null;
		},

		_canUpdateStatus: function() {
			// summary: do not allow if in Admin-only mode
			return configuration.canUpdateStatus();
		},

		/**
		 * Return action to render user role and selection, if any
		 * @return {Action}
		 */
		_getRoleAction: function() {
			const roleActions = [];
			const {playableRolesStore} = sessionStore;
			const {labelProperty} = playableRolesStore;
			const roles = playableRolesStore.internalQuery();
			const all = locale.resource("SelectAll");
			const urlCurrentRole = sessionConstants.roleUrl || csi.EMPTY_URL;
			let roleLabel;
			let roleTitle;

			if (roles.length > 0 && crews.isAdmin()) {
				roles.unshift(csiStore.nameObject(all));
			}

			_.each(roles, function(item) {
				const url = playableRolesStore.getIdentity(item);
				const name = item[labelProperty];
				const a = _getRoleAction(name, url);

				if (url == urlCurrentRole) {
					roleTitle = locale.resource("SelectRole", [item[labelProperty]]);
					roleLabel = name;
				} else {
					roleActions.push(a);
				}
			}, this);

			if (roleActions.length) {
				return {
					name: roleLabel,
					title: roleTitle,
					showLabel: true,
					materialIcon: "lock",
					children: roleActions,
					className: "csi-nav-dropdown"
				};
			} else if (roleLabel) {
				return lang.mixin(new Action(), {
					m_id: "SelectRole",
					m_name: roleLabel,
					m_typeControl: def.ACTION_BUTTON
				});
			}

			return null;
		},

		/**
		 * Create actions available on the toolbar for this user
		 */
		_initViewActions: function() {
			const {defView} = this;
			const add = (params, ctr = Action) => defView._addViewAction(new ctr(), params);

			// below constants cannot change while page is loaded
			const isAdmin = crews.isAdmin();
			const isConfigEditor = sessionConstants.configEditor;
			const hasCamunda = modules.hasModule("Camunda");
			const hasConfig = sessionConstants.setupViewer;
			const hasFavorites = reflection.getClass("Favorite").enabled;
			const hasHelp = state.get("helpFile");

			// delay setting params until state is known
			USER_PROFILE.classToolbarPluginParams = _getAnchorParams(sessionConstants.userUrl);

			add(USER_NAME);
			add(USER_PROFILE);
			add(LOGOUT);

			if (!sessionConstants.isPortalUser) {
				add(DATA_SETUP_LABEL);
				add(EMAIL);
				add(HELP_LABEL);
				add(IMAGE_LIBRARY);
				add(LAST_VISITED);
				add(NOTIFICATION);
				add(ROLLUP, Popup);
				add(SHOW_HELP);
				add(SYSTEM_REPORTING_LABEL);

				if (hasFavorites) {
					add(FAVORITE);
				}

				if (hasHelp) {
					add(HELP);
				}

				if (hasCamunda) {
					add(TASKS);
				}

				if (hasConfig) {
					add(SYSTEM_CONFIGURATION);

					if (isConfigEditor) {
						add(UPDATE_CONFIGURATION);
						add(IMPORT_CONFIGURATION, SubmitAction);
						add(EXPORT_CONFIGURATION, DownloadAction);
					}

					if (isAdmin) {
						add(ADMIN_ONLY);
						add(ADMIN_ONLY_ICON);
					}
				}

				// add data setup actions
				for (const section of dataSetupStore.sections) {
					add(_getDataSetupActionParams(section));
				}
			}
		},

		/**
		 * Write operation to server to toggle admin-only mode
		 * @param {Controller}
		 */
		_onActionAdminOnly: function(ac) {
			ac.m_writer.callMethod("UserProvider", sessionStore.adminOnly ? "AllowAccessForNonAdminUsers" : "RestrictAccessForNonAdminUsers");
		},

		/**
		 * Toggle adminOnly mode and redraw so security icon / user delegation appear correctly
		 */
		_postActionAdminOnly: function() {
			sessionStore.setAdminOnly(!sessionStore.adminOnly);
			this.redraw();
		},

		_preUpdateConfiguration: function(/*Controller*/ac) {
			// summary: get the current status and return false if configuration is already being updated
			return configurationUtil.preActionUpdateConfiguration(ac);
		},

		_postImportConfiguration: function() {
			// summary: show the dialog and force refresh again so UI responds correctly
			new MessageDialog({
				buttons: [MessageDialog.BUTTON_OK],
				materialIcon: MessageDialog.ICON_COMPLETED,
				message: locale.resource("ImportConfiguration_Finished"),
				title: locale.resource("ImportConfiguration"),
			}).show();

			return configuration.refreshStatus();
		},

		_postUpdateConfiguration: function() {
			// summary: force refresh again so UI responds correctly
			return configuration.refreshStatus();
		},

		/**
		 * Remove Last Visited and Favorites drop-downs so that they will be recreated when next used
		 */
		_resetDropDowns: function() {
			const {headerToolbar} = this;

			if (headerToolbar) {
				headerToolbar.getPlugin(ACTION_FAVORITES).resetDropDown();
				headerToolbar.getPlugin(ACTION_LAST_VISITED).resetDropDown();
			}
		},

		/**
		 * Reset toolbar plugins to those available in the correct order
		 */
		_resetToolbarPlugins: function() {
			const {defView} = this;
			const plugins = this.plugins = [];
			const separator = "|";

			const getAction = (params) => params && defView.getAction(params.m_id);

			const addSeparator = (withSeparator) => {
				if (withSeparator && plugins.length) {
					plugins.push(separator);
				}
			};

			const addAction = (params, withSeparator) => {
				const action = getAction(params);
				if (action) {
					addSeparator(withSeparator);
					plugins.push(action);
				}

				return action;
			};

			const addMenu = (menuParams, withSeparator, ...actionGroups) => {
				const children = [];

				// determine actions in the menu
				for (const group of actionGroups) {
					const groupActions = _.compact(group.map(getAction));

					if (groupActions.length) {
						if (children.length) {
							children.push(separator);
						}

						children.push(...groupActions);
					}
				}

				if (children.length) {
					// there are actions to show in the menu, so add separator if necessary and then menu
					addSeparator(withSeparator);

					plugins.push(Object.assign({
						children,
						className: "csi-nav-dropdown",
						showLabel: false
					}, menuParams));
				}
			};

			// left side
			addAction(LAST_VISITED);
			addAction(TASKS);
			addAction(NOTIFICATION);
			addAction(FAVORITE);
			addAction(IMAGE_LIBRARY);

			// setup
			const {serviceSection, setupSections} = dataSetupStore;
			const servicesAction = _getDataSetupActionParams(serviceSection);
			const setupActions = setupSections.map(_getDataSetupActionParams);

			if (setupActions.length) {
				setupActions.unshift(DATA_SETUP_LABEL);
			}

			addMenu(HELP_MENU, true, [HELP_LABEL, HELP, SHOW_HELP], [SYSTEM_REPORTING_LABEL, servicesAction, ROLLUP]);
			addMenu(DATA_SETUP_MENU, false, setupActions);
			addMenu(SYSTEM_MENU, false, [SYSTEM_CONFIGURATION], [UPDATE_CONFIGURATION, IMPORT_CONFIGURATION, EXPORT_CONFIGURATION], [ADMIN_ONLY]);

			// user
			addSeparator(true);

			if (sessionStore.adminOnly) {
				addAction(ADMIN_ONLY_ICON);
			}

			if (sessionConstants.showUserNameOnHeader) {
				// user name can change, so update each time rendered
				const userNameAction = addAction(USER_NAME);
				userNameAction.m_name = sessionStore.userName;
				userNameAction.classToolbarPluginParams = _getAnchorParams(sessionConstants.userUrl);
			}

			// list of playable roles can change, so need to recompute each time
			const roleAction = this._getRoleAction();
			if (roleAction) {
				plugins.push(roleAction);
			}

			addMenu(USER_MENU, false, [USER_PROFILE, EMAIL], [LOGOUT]);
		}
	});
});
